// Vector-state predicates ported from data_centrifuge_view.coffee:703-744.
// Pure functions over componentData (+ data for the quarantine check) — no
// instance state, so they can be shared by the list-props builder, the
// component-props builder, and the vector-toggle mutators.

import { VECTORS_GROUPS } from '@aytm/app/stats/page/data-centrifuge/lib/vectors'

// Composite check: is auto-quarantine effectively on right now? `features`
// (page.model.features) and `surveyConfig` (survey.config) are both threaded in from
// the shim — no getFeatures() / window.survey reads here.
export const isDcQuarantineEnabled = (componentData, data, features = {}, surveyConfig = null) => {
  let result =
    componentData.quarantineUIDs.length > 0 ||
    (Object.hasOwn(surveyConfig || {}, 'dcQuarantine') && surveyConfig.dcQuarantine)
  result ||= Object.hasOwn(data, 'dcQuarantine') && data.dcQuarantine
  // Never-run survey: default quarantine ON unless an admin opted out. Tests the VALUE, not key
  // presence — the report payload always carries the timestamp key (null when never run), so a
  // key-presence check here never fires.
  result ||= (!componentData.dcLastRunTs && !features?.stat_data_cleaning_run_auto_quarantine?.disabled) || false
  return result
}

// True for top-level vectors that ran successfully but produced no scores (no
// entry in vectorIds). Such rows stay visible in the sidebar without the disabled
// visual; setData adds them to disabledVectors so chart/scoring still skip them.
export const isAutoEnabledLikeVector = (componentData, id) => {
  if (componentData.vectorIds.includes(id)) return false

  const statuses = componentData.dcStatuses || {}
  if (statuses[id]?.status?.toLowerCase() === 'success') return true

  // Source the children list from the static group config (always available)
  // rather than componentData.groups (runtime, may not be seeded at every call site).
  const group = VECTORS_GROUPS.find(g => g.id === id)
  if (!group) return false

  const runtimeGroup = componentData.groups?.[id]

  // Any child with actual scores breaks the "ran clean" property; otherwise look
  // for a 'success' status on any leaf.
  let hasSuccessLeaf = false
  for (const childId of group.vectors) {
    if ((runtimeGroup?.[childId]?.total || 0) > 0) return false
    if (statuses[childId]?.status?.toLowerCase() === 'success') hasSuccessLeaf = true
  }
  return hasSuccessLeaf
}

export const isAutoEnabledLikeSubVector = (componentData, childId, item) => {
  if (item.total) return false

  const statuses = componentData.dcStatuses || {}
  return statuses[childId]?.status?.toLowerCase() === 'success'
}
